import { BaseWebComponentController } from '../../../../../../framework/BaseWebComponentController';
import { ChildGroupsGridWebComponent } from '../component/ChildGroupsGridWebComponent';
import { ChildGroupsGridView } from '../view/ChildGroupsGridView';
import { templateChildGroupsGrid } from '../view/template';

export class ChildGroupsGridController extends BaseWebComponentController {
  constructor(component: ChildGroupsGridWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: ChildGroupsGridView,
      viewTemplate: templateChildGroupsGrid,
    });
  }
}
